/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Hero_TitleInputs */



/**
* | output |
* | --- |
* | "Vessel inspections by people who have run the ship." |
*
* @param {Home_Hero_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const home_hero_title = /** @type {((inputs?: Home_Hero_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Hero_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("由真正管理过船舶的人来做船舶检查。")
	return /** @type {LocalizedString} */ ("Vessel inspections by people who have run the ship.")
});